import { CheckOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, Input, Row, Select, Space } from "antd";
import { MaskedInput } from "antd-mask-input";
import { useEffect, useRef, useState } from "react";
import { setModalCadastrarContatoPessoa } from "../../../../../redux/slices/contatoPessoa/contatoPessoaSlice";
import { useAppDispatch, useAppSelector } from "../../../../../util/hooks";
import { buscarCep, listarEstado } from "../../../../../services/localizacaoService";
import dayjs from "dayjs";
import { ContatoPessoaModel } from "../../../../../models/contatoPessoa/contatoPessoaModel";
import { atualizarContatoPessoa, cadastrarContatoPessoa } from "../../../../../services/contatoPessoaService";
import { EstadoModel } from "../../../../../models/localizacao/estadoModel";
import { mascaraCelular, mascaraCep, mascaraData, mascaraTelefoneFixo } from "../../../../../util/mascaras";

dayjs.locale("pt-br");

const CadastrarContatoModal = () => {
  //estados globais
  const localizacaoState = useAppSelector((state) => state.localizacao);
  const contatoPessoaState = useAppSelector((state) => state.contatoPessoa);
  const pessoaState = useAppSelector((state) => state.pessoa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [inputCep, setInputCep] = useState<string>("");

  const inputNumero = useRef<any>(null);
  const campoCep = useRef<any>(null);

  const editar = Object.values(contatoPessoaState.entity).length !== 0;

  useEffect(() => {
    dispatch(listarEstado());
    if (editar) {
      setInputCep(contatoPessoaState.entity.cep);
      form.setFieldsValue({ ...contatoPessoaState.entity, dataAniversario: dayjs(contatoPessoaState.entity.dataAniversario) });
    } else {
      setInputCep("");
    }
  }, [contatoPessoaState.entity]);

  const submit = (value: any) => {
    const contato: ContatoPessoaModel = { ...value };
    contato.idPessoa = pessoaState.entity.id;
    contato.idTipoContatoPessoa = value.idTipoContatoPessoa;
    contato.dataAniversario = value.dataAniversario;
    contato.celular = value.celular?.replace(/[^0-9]/g, "");
    contato.telefone = value.telefone?.replace(/[^0-9]/g, "");
    contato.cep = value.cep?.replace(/[^0-9]/g, "");
    if (editar) {
      contato.id = contatoPessoaState.entity.id;
      contato.ativo = contatoPessoaState.entity.ativo;
      dispatch(atualizarContatoPessoa({ value: contato, busca: pessoaState.entity.id }));
    } else {
      dispatch(cadastrarContatoPessoa({ value: contato, busca: pessoaState.entity.id }));
    }
  };

  const onBuscarCep = async () => {
    const retorno = await dispatch(buscarCep(inputCep));

    form.setFieldsValue({
      endereco: retorno.payload.logradouro,
      bairro: retorno.payload.bairro,
      cidade: retorno.payload.localidade,
      idEstado: localizacaoState.listEstado.filter((a: EstadoModel) => a.sigla === retorno.payload.uf)[0].id,
    });

    inputNumero.current.focus();
  };

  const voltar = () => {
    dispatch(setModalCadastrarContatoPessoa(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col flex="auto" span={18}>
          <Form.Item
            label="Nome"
            name="nome"
            rules={[
              {
                required: true,
                message: "Digite o nome",
                validateTrigger: "onSubmit",
              },
            ]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col flex="auto" span={8}>
          <Form.Item
            label="Tipo Contato"
            name="idTipoContatoPessoa"
            rules={[
              {
                required: true,
                message: "Selecione o tipo contato",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="label"
              loading={contatoPessoaState.loadingTipo}
              options={contatoPessoaState.listTipo.map((a: any) => ({
                value: a.id,
                label: a.denominacao,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col flex="auto" span={9}>
          <Form.Item label="E-mail" name="email">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col flex="auto" span={5}>
          <Form.Item label="Telefone" name="telefone">
            <MaskedInput mask={mascaraTelefoneFixo()} />
          </Form.Item>
        </Col>
        <Col flex="auto" span={5}>
          <Form.Item label="Celular / WhatsApp" name="celular">
            <MaskedInput mask={mascaraCelular()} />
          </Form.Item>
        </Col>
        <Col flex="auto" span={5}>
          <Form.Item label="Data de nascimento" name="dataAniversario">
            <MaskedInput mask={mascaraData()} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col flex="auto" span={6}>
          <Form.Item label="CEP" name="cep">
            <MaskedInput mask={mascaraCep()} onChange={(e) => setInputCep(e.target.value)} ref={campoCep} />
          </Form.Item>
        </Col>
        <Col className="colCepButton">
          <Form.Item label=" ">
            <Button className="cepButton" onClick={onBuscarCep}>
              Buscar
            </Button>
          </Form.Item>
        </Col>
        <Col flex="auto" span={14}>
          <Form.Item label="Endereço" name="endereco">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col flex="auto" span={4}>
          <Form.Item label="Número" name="numero">
            <Input type="text" ref={inputNumero} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col flex="auto" span={6}>
          <Form.Item label="Complemento" name="complemento">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col flex="auto" span={8}>
          <Form.Item label="Bairro" name="bairro">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col flex="auto" span={8}>
          <Form.Item label="cidade" name="cidade">
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col flex="auto" span={2}>
          <Form.Item label="UF" name="idEstado">
            <Select
              autoFocus
              showSearch
              optionFilterProp="label"
              loading={localizacaoState.loadingEstado}
              options={localizacaoState.listEstado.map((a: any) => ({
                value: a.id,
                label: a.sigla,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <div className="modalFooter">
        <Space size="middle">
          <Button className="cancelButton" onClick={voltar} icon={<LeftOutlined />}>
            VOLTAR
          </Button>
          <Button className="buttonPrimary" type="primary" htmlType="submit" icon={<CheckOutlined />}>
            SALVAR
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default CadastrarContatoModal;
